module.exports = __webpack_public_path__ + "static/media/Inter-SemiBold.65cbb751.ttf";